import { h, clear } from '../utils/dom.js';

export function renderCompareView(container, state, actions) {
	clear(container);

	const { compare, translations, book, chapter, i18n } = state;
	const wrap = h('div', { class: 'blb-reader-inner' });

	const bookMeta = state.index && state.index.books.find((b) => b.id === book);
	const title = bookMeta ? `${bookMeta.name} ${chapter}` : `${book} ${chapter}`;

	wrap.appendChild(
		h('div', { class: 'blb-reader-header blb-compare-header' }, [
			h('div', null, [
				h('h2', { class: 'blb-reader-title' }, title),
				h('p', { class: 'blb-reader-sub' }, `${i18n.compareTitle || 'Compare Translations'} — ${compare.selected.length}`),
			]),
			h('button', { class: 'blb-toolbar-btn', onClick: () => actions.exitCompare() }, `✕ ${i18n.exitCompare || 'Exit Compare'}`),
		])
	);

	if (compare.loading) {
		wrap.appendChild(
			h('div', { class: 'blb-empty-state' }, [h('span', { class: 'blb-spinner' }), h('p', null, i18n.loading)])
		);
		container.appendChild(wrap);
		return;
	}

	const translationMeta = (id) => (translations || []).find((t) => t.id === id) || { id, abbrev: id.toUpperCase(), name: id };

	const verseNumbers = new Set();
	compare.selected.forEach((id) => {
		const data = compare.data[id];
		if (data) data.verses.forEach((v) => verseNumbers.add(v.verse));
	});
	const sortedVerses = [...verseNumbers].sort((a, b) => a - b);

	if (sortedVerses.length === 0) {
		wrap.appendChild(h('div', { class: 'blb-missing-chapter' }, h('p', null, i18n.chapterMissing)));
		container.appendChild(wrap);
		return;
	}

	const compareEl = h('div', { class: 'blb-compare-view' });

	sortedVerses.forEach((verseNum) => {
		const block = h('div', { class: 'blb-compare-block' }, [h('div', { class: 'blb-compare-verse-num' }, `Verse ${verseNum}`)]);

		compare.selected.forEach((translationId) => {
			const meta = translationMeta(translationId);
			const data = compare.data[translationId];
			const verse = data && data.verses.find((v) => v.verse === verseNum);

			block.appendChild(
				h('div', { class: 'blb-compare-row-item' }, [
					h('span', { class: 'blb-badge blb-badge-blue blb-compare-tag' }, meta.abbrev),
					h(
						'span',
						{ class: verse ? 'blb-compare-text' : 'blb-compare-text blb-compare-text-missing' },
						verse ? verse.text : i18n.notInTranslation || 'Not present in this translation.'
					),
				])
			);
		});

		compareEl.appendChild(block);
	});

	wrap.appendChild(compareEl);
	container.appendChild(wrap);
}
